import { ColumnDef } from './StructureTable.types';

export const reorderByVisibleIndex = (
  columns: ColumnDef[],
  oldVisibleIndex: number,
  newVisibleIndex: number
): ColumnDef[] => {
  if (oldVisibleIndex === newVisibleIndex) return columns;

  const visible = columns.filter((c) => c.visible);
  const movedKey = visible[oldVisibleIndex]?.key;
  const targetKey = visible[newVisibleIndex]?.key;
  if (!movedKey || !targetKey) return columns;

  const fromFull = columns.findIndex((c) => c.key === movedKey);
  const toFull = columns.findIndex((c) => c.key === targetKey);
  if (fromFull === -1 || toFull === -1) return columns;

  const next = [...columns];
  const [moved] = next.splice(fromFull, 1);
  next.splice(toFull, 0, moved);
  return next;
};

export const applyColumnOrder = (
  columns: ColumnDef[],
  order: Array<{ field: string }>
): ColumnDef[] => {
  if (!order.length) return columns;

  const orderMap = new Map(order.map((c, i) => [c.field, i]));
  return [...columns].sort((a, b) => {
    const ai = orderMap.get(a.key) ?? Infinity;
    const bi = orderMap.get(b.key) ?? Infinity;
    if (ai === Infinity && bi === Infinity) return 0;
    return ai - bi;
  });
};
